import { client } from "api";
import { TimeEntry } from "models/TimeEntry";

export type FilterAllTimeEntriesRequest = {
  searchQuery: string;
  fromDate: string | null; // ISO string
  toDate: string | null; // ISO string
  states: ("PENDING" | "APPROVED" | "REJECTED")[] | null;
  types: number[] | null;
  processed: boolean | null;
  officeIds: number[] | null;
  departmentIds: number[] | null;
};

export type FilterAllTimeEntriesResponse = TimeEntry[];

export const filterAllTimeEntries = (
  request: FilterAllTimeEntriesRequest
): Promise<FilterAllTimeEntriesResponse> =>
  client.post<FilterAllTimeEntriesResponse>("/absence/filterAll", request).then((res) => res.data);
